import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const InlineCode = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill={color}
          d="M5.61134 13.5852C5.52401 13.8472 5.66559 14.1304 5.92756 14.2177C6.18954 14.305 6.4727 14.1634 6.56002 13.9015L10.3889 2.41472C10.4763 2.15275 10.3347 1.86959 10.0727 1.78226C9.81073 1.69494 9.52757 1.83652 9.44025 2.09849L5.61134 13.5852ZM4.6131 4.65396C4.41784 4.45869 4.10125 4.45869 3.90599 4.65396L0.913536 7.64641C0.718274 7.84167 0.718274 8.15826 0.913536 8.35352L3.90599 11.346C4.10125 11.5412 4.41784 11.5412 4.6131 11.346C4.80836 11.1507 4.80836 10.8341 4.6131 10.6389L1.9742 7.99996L4.6131 5.36106C4.80836 5.1658 4.80836 4.84922 4.6131 4.65396ZM11.3869 4.65396C11.5822 4.45869 11.8988 4.45869 12.094 4.65396L15.0865 7.64641C15.2817 7.84167 15.2817 8.15826 15.0865 8.35352L12.094 11.346C11.8988 11.5412 11.5822 11.5412 11.3869 11.346C11.1917 11.1507 11.1917 10.8341 11.3869 10.6389L14.0258 7.99996L11.3869 5.36106C11.1917 5.1658 11.1917 4.84922 11.3869 4.65396Z"
        />
      </svg>
    )
  },
)

export default InlineCode
